import { render, staticRenderFns } from "./TrustPilotRating.vue?vue&type=template&id=2a4eb3a6&scoped=true"
import script from "./TrustPilotRating.vue?vue&type=script&setup=true&lang=ts"
export * from "./TrustPilotRating.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TrustPilotRating.vue?vue&type=style&index=0&id=2a4eb3a6&prod&scoped=true&lang=css"
import style1 from "./TrustPilotRating.vue?vue&type=style&index=1&id=2a4eb3a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.47_babel-core@7.0.0-bridge.0_@babel+core@7.20.12__cs_dsp4ve4m4u4ggk2pimednah2wa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4eb3a6",
  null
  
)

export default component.exports